export const DATA_UPDATE = 'DATA_UPDATE';
export const PROPERTY_TYPE_UPDATE = 'PROPERTY_TYPE_UPDATE';
export const NUMBER_OF_ROOMS_UPDATE = 'NUMBER_OF_ROOMS_UPDATE';
export const ESTIMATED_REVENUE_UPDATE = 'ESTIMATED_REVENUE_UPDATE';
export const LOCATION_UPDATE = 'LOCATION_UPDATE';
export const LOCATION_OBJECT_UPDATE = 'LOCATION_OBJECT_UPDATE';

export const CAROUSEL_MODE_UPDATE = 'CAROUSEL_MODE_UPDATE';

export const START_FETCH_PAGE_DATA = 'START_FETCH_PAGE_DATA';
export const SUCCESS_FETCH_PAGE_DATA = 'SUCCESS_FETCH_PAGE_DATA';

export const FETCH_SEARCH = 'FETCH_SEARCH';

export const START_FETCH_SEARCH = 'START_FETCH_SEARCH';

export const SUCCESS_FETCH_SEARCH = 'SUCCESS_FETCH_SEARCH';

export const START_PUT_PROPERTY = 'START_PUT_PROPERTY';

export const SUCCESS_PUT_PROPERTY = 'SUCCESS_PUT_PROPERTY';

export const FLIP_SCROLL_TO_STEPS_BOOL = 'FLIP_SCROLL_TO_STEPS_BOOL';

export const FLIP_SCROLL_TO_PROGRAMS_BOOL = 'FLIP_SCROLL_TO_PROGRAMS_BOOL';

export const ARE_YOU_A_SELLER_BOOL = 'ARE_YOU_A_SELLER_BOOL';

export const EMPTY_FORM_DATA = 'EMPTY_FORM_DATA';

export const MOBILE_HEADER_HEIGHT = 'MOBILE_HEADER_HEIGHT';

export const START_GET_EARNING_POTENTIAL = 'START_GET_EARNING_POTENTIAL';
export const GET_EARNING_POTENTIAL_SUCCESS = 'GET_EARNING_POTENTIAL_SUCCESS';

export const START_SIGN_UP = 'START_SIGN_UP';
export const SUCCESS_SIGN_UP = 'SUCCESS_SIGN_UP';
export const ERROR_SIGN_UP = 'ERROR_SIGN_UP';

export const START_LOGIN = 'START_LOGIN';
export const SUCCESS_LOGIN = 'SUCCESS_LOGIN';
export const ERROR_LOGIN = 'ERROR_LOGIN';

export const START_OTP = 'START_OTP';
export const SUCCESS_OTP = 'SUCCESS_OTP';
export const ERROR_OTP = 'ERROR_OTP';
export const SUCCESS_PUT_PROPERTY_GEN_OTP = 'SUCCESS_PUT_PROPERTY_GEN_OTP';

export const UPDATE_GLOBAL_DATA = 'UPDATE_GLOBAL_DATA';